<template>
  <div class="resetpass-container">
    <GlobalLoading v-if="$store.state.modalStore.isGlobalLoading" />
    <Notif v-if="$store.state.showModalNotif" />
    <b-form-group
      id="fieldset-1"
      label="Enter New Password"
      label-for="input-1"
      :invalid-feedback="invalidPass"
      :valid-feedback="validPass"
      :state="passState"
    >
      <b-form-input
        id="input-1"
        type="password"
        v-model="pass"
        :state="passState"
        trim
      ></b-form-input>
    </b-form-group>
    <b-form-group
      id="fieldset-1"
      label="Confirm Password"
      label-for="input-2"
      :invalid-feedback="invalidConfirm"
      :valid-feedback="validConfirm"
      :state="confirmState"
    >
      <b-form-input
        id="input-2"
        type="password"
        v-model="confirm"
        :state="confirmState"
        trim
      ></b-form-input>
    </b-form-group>
    <b-button @click="resetPass">Reset Password</b-button>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '../services/config'
export default {
  name: 'resetpass',
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  data() {
    return {
      pass: '',
      confirm: '',
      token: null,
    }
  },
  created() {
    const self = this
    self.token = self.$router.currentRoute.query.token
    if (!self.token) {
      self.$router.push({ name: 'home' })
    }
  },
  computed: {
    passState() {
      return this.pass.length >= 8 ? true : false
    },
    invalidPass() {
      if (this.pass.length >= 8) {
        return ''
      } else if (this.pass.length > 0) {
        return 'Enter at least 8 characters'
      } else {
        return 'Please enter new password'
      }
    },
    validPass() {
      return this.passState === true ? 'Correct' : ''
    },
    confirmState() {
      if (this.pass == this.confirm && this.confirm.length >= 8) {
        return true
      }
      return false
    },
    invalidConfirm() {
      if (this.confirm.length >= 8) {
        return this.confirmState === true
          ? 'Correct'
          : 'Password does not match'
      } else if (this.confirm.length > 0) {
        return 'Enter at least 8 characters'
      } else {
        return 'Please enter confirm password'
      }
    },
    validConfirm() {
      return this.confirmState === true ? 'Correct' : ''
    },
  },
  methods: {
    resetPass() {
      const self = this
      self.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      if (this.pass == this.confirm) {
        axios({
          method: 'POST',
          url: `${api}/api/v1/auth/reset`,
          data: {
            token: self.token,
            password: self.pass,
            confirmation: self.confirm,
          },
        })
          .then(response => {
            self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            self.$store.commit('SET_NOTIF', 'Password Anda Telah Diganti.')

            setTimeout(() => {
              self.$router.push({ name: 'home' })
            }, 2000)
          })
          .catch(error => {
            self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            self.$store.commit(
              'SET_NOTIF',
              self.$get(
                error,
                'response.data.message',
                'Maaf, terjadi error, silahkan ulangi'
              )
            )
          })
      }
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/components/resetpass.scss';
</style>
